var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogo = function SvgLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124,
    height: 20,
    viewBox: "0 0 124 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 339",
    d: "M0 0h124v18.576H0z",
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v20H0z",
    opacity: 0.1,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 487"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 8142",
    d: "M21.259 1.229l-4.145 14.484L12.6 1.229h-1.964l-4.49 14.484L1.978 1.229H0l5.088 17.543h1.993L11.63 4.201l4.526 14.571h1.993l5.088-17.543z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 486"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 485",
    transform: "translate(0 .712)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 8143",
    d: "M57.384 12.923c0 3.109-2.532 5.139-5.665 5.139h-7.37V.514h6.868c3.058 0 5.54 1.98 5.54 5.014a4.392 4.392 0 01-1.529 3.434 4.531 4.531 0 012.156 3.961M48.36 4.275v3.108h2.858a1.481 1.481 0 001.529-1.554 1.467 1.467 0 00-1.529-1.554zm5.018 8.348a1.585 1.585 0 00-1.654-1.679h-3.359v3.359h3.359a1.586 1.586 0 001.654-1.68"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 8144",
    d: "M72.927 14.2v3.859H61.604V.516h4.01V14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 338",
    d: "M78.084.517h4.043V18.06h-4.043z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 8145",
    d: "M102.084.52v17.536h-3.033L91.482 8.48v9.576h-4.041V.52h3.032l7.569 9.452V.52z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 8146",
    d: "M38.723 2.324V.517h-10.8V18.06h10.8v-1.807h-8.916v-6.184h8.747V8.261h-8.747V2.324z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 8147",
    d: "M124 9.3c0 5.964-3.483 9.274-8.336 9.274a9.28 9.28 0 01-9.361-9.331A8.993 8.993 0 01115.184 0a8.867 8.867 0 017.577 3.962l-3.189 1.829a4.756 4.756 0 00-4.155-1.928 5.209 5.209 0 00-5.155 5.407c0 2.947 1.873 5.443 5.241 5.443 2.791 0 4.308-1.77 4.433-3.637h-4.631v-3.26h8.637z"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "logo.280e319f03a25fac084ccfe117a13501.svg";